import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated, getStoredAuthRole, getDashboardRoute } from "../utils/auth";

const GuestRoute = ({ children, redirectTo = null }) => {
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  const authenticated = isAuthenticated();
  const role = getStoredAuthRole();

  useEffect(() => {
    const timeout = window.setTimeout(() => setIsReady(true), 50);
    return () => window.clearTimeout(timeout);
  }, []);

  if (!isReady) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] text-lg text-teal-700">Checking access…</div>;
  }

  if (authenticated) {
    return <Navigate to={redirectTo || getDashboardRoute(role)} replace state={{ from: location }} />;
  }

  return children;
};

export default GuestRoute;
